import { useQuery } from '@tanstack/react-query';

import { useErrorMessage } from '#error-message/useErrorMessage';

import { AuthService } from './authService';
import { AuthKey } from './keys';

export function useGetSignup(token?: string) {
  const signupQuery = useQuery({
    queryKey: [AuthKey.SIGNUP, token],
    queryFn: () => AuthService.getSignup(token).then((response) => response.data),
  });

  const errorMessage = useErrorMessage(signupQuery.error);

  return {
    ...signupQuery,
    errorMessage,
  };
}
